import AppLayout from '@pages/_layout/AppLayout';
import { RouteObject } from 'react-router';
import UserPanel from '.';

export default [
  {
    path: 'users',
    element: <AppLayout />,
    children: [{ index: true, element: <UserPanel /> }],
  },
] as RouteObject[];
